import React from "react";
import { useNavigate } from "react-router-dom";
import { Check } from "lucide-react";
export const Pricing = () => {
  const navigate = useNavigate();
  const handleStartFree = () => {
    navigate("/dashboard");
  };
  return <div className="py-20 bg-[#d5ff00]/10" data-id="element-1379">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1380">
        <div className="text-center mb-16" data-id="element-1381">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-1382">
            Simple Credit-Based Pricing
          </h2>
          <p className="text-xl text-gray-600" data-id="element-1383">
            Start free, scale when you're ready
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-1384">
          <div className="bg-white p-8 rounded-lg shadow-xl border border-gray-200 transform hover:scale-105 transition-transform duration-300" data-id="element-1385">
            <h3 className="text-xl font-semibold mb-4 text-[#6366f1]" data-id="element-1386">
              Starter
            </h3>
            <div className="mb-6" data-id="element-1387">
              <span className="text-4xl font-bold text-gray-900" data-id="element-1388">Free</span>
              <div className="text-[#6366f1] text-sm mt-2" data-id="element-1389">
                20 credits to start
              </div>
            </div>
            <ul className="space-y-4 mb-8" data-id="element-1390">
              <Feature text="One campaign" data-id="element-1391" />
              <Feature text="Standard AI targeting" data-id="element-1392" />
              <Feature text="Basic personalization" data-id="element-1393" />
              <Feature text="Campaign dashboard" data-id="element-1394" />
              <Feature text="Email support" data-id="element-1395" />
            </ul>
            <button onClick={handleStartFree} className="w-full py-4 bg-[#d5ff00] text-gray-900 rounded-lg hover:bg-[#c0e600] shadow-lg font-semibold text-lg" data-id="element-1396">
              Start Free
            </button>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-xl border-2 border-[#6366f1] relative transform hover:scale-105 transition-transform duration-300" data-id="element-1397">
            <div className="absolute top-0 right-0 bg-[#6366f1] text-white px-4 py-1 rounded-bl-lg rounded-tr-lg text-sm font-semibold" data-id="element-1398">
              MOST POPULAR
            </div>
            <h3 className="text-xl font-semibold mb-4 text-[#6366f1]" data-id="element-1399">Pro</h3>
            <div className="mb-6" data-id="element-1400">
              <span className="text-4xl font-bold text-gray-900" data-id="element-1401">$99</span>
              <span className="text-gray-500 ml-2" data-id="element-1402">/ month</span>
              <div className="text-[#6366f1] text-sm mt-2" data-id="element-1403">
                100 credits included
              </div>
            </div>
            <ul className="space-y-4 mb-8" data-id="element-1404">
              <Feature text="Unlimited campaigns" data-id="element-1405" />
              <Feature text="Advanced AI targeting" data-id="element-1406" />
              <Feature text="Deep personalization" data-id="element-1407" />
              <Feature text="Full analytics suite" data-id="element-1408" />
              <Feature text="Priority support" data-id="element-1409" />
              <Feature text="Multiple team members" data-id="element-1410" />
            </ul>
            <button onClick={handleStartFree} className="w-full py-4 bg-[#d5ff00] text-gray-900 rounded-lg hover:bg-[#c0e600] shadow-lg font-semibold text-lg" data-id="element-1411">
              Upgrade to Pro
            </button>
          </div>
        </div>
      </div>
    </div>;
};
const Feature = ({
  text
}) => <li className="flex items-center" data-id="element-1412">
    <Check size={20} className="text-[#6366f1] mr-2" data-id="element-1413" />
    <span className="text-gray-600" data-id="element-1414">{text}</span>
  </li>;